<template>
  <v-card class="fill-height"
          :loading="chartLoading">
    <v-card-title>
      <slot name="title"></slot>
    </v-card-title>
    <v-card-text class="px-8">
      <apexchart v-if="chartLoading === false"
                 type="area"
                 :height="chartHeight"
                 :options="chartOptions"
                 :series="chartSeries">
      </apexchart>
      <div v-else
           :style="`height: ${chartHeight}px`">
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import mailgunService from '../../../../../ml/services/mailgunService';

export default {
  props: {
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    sender: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      emails: [],
      deliveries: [],
      opens: [],
      clicks: [],
      failures: [],
      //complaints: [],
      chartHeight: 300,
      chartLoading: false,
      chartOptions: null,
      chartSeries: [],
    }
  },
  computed: {
    senderID() {
      return this.sender.id;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      await this.getDailyMetrics();
    },
    async getDailyMetrics() { // MLD-6072
      const days = this.days;
      this.chartLoading = true;
      // @see https://apexcharts.com/javascript-chart-demos/column-charts/basic/
      const form = {
        start: this.start,
        end: this.end,
      }
      await Promise.all([
        mailgunService.getDailyEmailMetricsForCurrentUser('created_date', form).then(data => this.emails = data),
        mailgunService.getDailyEmailMetricsForCurrentUser('delivered_date', form).then(data => this.deliveries = data),
        mailgunService.getDailyEmailMetricsForCurrentUser('opened_date', form).then(data => this.opens = data),
        mailgunService.getDailyEmailMetricsForCurrentUser('clicked_date', form).then(data => this.clicks = data),
        mailgunService.getDailyEmailMetricsForCurrentUser('failed_date', form).then(data => this.failures = data),
      ])
      this.chartSeries = [];
      this.chartSeries.push({
        name: 'Sent',
        data: this.emails.map(r => r.value),
      })
      this.chartSeries.push({
        name: 'Delivered',
        data: this.deliveries.map(r => r.value),
      })
      this.chartSeries.push({
        name: 'Opened',
        data: this.opens.map(r => r.value),
      })
      this.chartSeries.push({
        name: 'Clicked',
        data: this.clicks.map(r => r.value),
      })
      this.chartSeries.push({
        name: 'Failed',
        data: this.failures.map(r => r.value),
      })
      this.chartOptions = {
        chart: {
          toolbar: { // @see https://apexcharts.com/docs/options/chart/toolbar/
            tools: {
              download: false,
              pan: false,
              zoom: true,
              zoomin: false,
              zoomout: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        xaxis: { // @see https://apexcharts.com/docs/options/xaxis/
          type: 'datetime',
          categories: this.deliveries.map(r => r.date),
        },
        yaxis: { // @see https://apexcharts.com/docs/options/yaxis/
          forceNiceScale: true,
        },
      }
      this.chartLoading = false;
    }
  },
}
</script>
